// @flow

import React, { type Node } from 'react';
import { getSafeDueDate, useIncomingPayment } from '@tectonics/prs/incoming-payment';
import { formatDueDate } from '@tectonics/prs/boleto';
import { PaymentInfo } from './payment-info';
import { getWeekDay } from '@tectonics/prs/week-day';

export function DisplayDueDate(): Node {
  const incomingPayment = useIncomingPayment();
  if(incomingPayment.status !== 'PE')
    throw new Error(`Boleto: invalid payment status ${incomingPayment.status}, it should be PE`);

  const dueDate = getSafeDueDate(incomingPayment);
  return (
    <PaymentInfo label="Vencimento:" >
      {formatDueDate(dueDate)}
      <small style={{marginLeft: '0.1em'}}>
        ({getWeekDayText(dueDate)})
      </small>
    </PaymentInfo>
  );
}

function getWeekDayText(dueDate): string {
  const weekDays = ['Seg', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Seg'];
  const weekDay = getWeekDay(dueDate, weekDays);

  return weekDay;
}
